import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["headerId", "children"];
import React from 'react';
export var MainRegion = regionBuilder('main');
export var BannerRegion = regionBuilder('banner');
export var NavigationRegion = regionBuilder('navigation');
export var Region = regionBuilder('region');
function regionBuilder(role) {
  return function (props) {
    var _ref = props,
      headerId = _ref.headerId,
      children = _ref.children,
      divProps = _objectWithoutProperties(_ref, _excluded);
    if (!isChildFunction(children)) {
      return /*#__PURE__*/React.createElement("section", _extends({}, divProps, {
        role: role
      }), children);
    }
    var regionId = headerId || "id".concat(Math.random());
    var childWithId = children(regionId);
    return /*#__PURE__*/React.createElement("section", _extends({}, divProps, {
      role: role,
      "aria-labelledby": regionId
    }), childWithId);
  };
}
function isChildFunction(children) {
  return typeof children === 'function';
}